// @ts-ignore
import debounce from 'lodash/debounce';

export class IntroTeaserVideo {
  container: HTMLElement;
  video: HTMLVideoElement;
  initialized: boolean = false;

  constructor(container) {
    this.container = container
    this.video = document.querySelector<HTMLVideoElement>('[data-intro-teaser-video="' + container.dataset.introTeaserVideoContainer + '"]');
    if (this.container && this.video) {
      this.initVideo();
      window.addEventListener("resize", debounce(() => {
        this.initVideo();
      }, 100));
    }
  }

  initVideo() {
    if (this.initialized || window.innerWidth < 992) {
      return;
    }
    this.container.appendChild(this.video.cloneNode(true));
    const video: HTMLVideoElement = this.container.querySelector('[data-intro-teaser-video]');
    let isSeeking: boolean = false;
    video.addEventListener('seeking', () => isSeeking = true);
    video.addEventListener('seeked', () => isSeeking = false);
    this.video.addEventListener("timeupdate", () => {
      const delta = (video.currentTime - this.video.currentTime) * 1000;
      if (Math.abs(delta) >= 50) {
        if (isSeeking === false) {
          video.currentTime = this.video.currentTime;
        }
      }
    });
    this.initialized = true;
  }

}
document.addEventListener("DOMContentLoaded", function() {
  document.querySelectorAll<HTMLElement>('[data-intro-teaser-video-container]').forEach((container: HTMLElement) => {
    new IntroTeaserVideo(container);
  });
});
